import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';

import { Grid } from '@mui/material';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';

import { concatWithDot } from 'helpers/string';

import { ABOUT_COMPANY_MAX_LENGTHS, SWOT_ROW_NAMES } from '../utils/form';

export const SwotAnalysisRow: FC<IProps> = memo(({ name, hiddenLabel, disabled = false }) => {
  const { control } = useFormContext();
  const id = concatWithDot(name, SWOT_ROW_NAMES.TITLE);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {/* TODO: id and undefined has been passed, so no label is applied (there is no for tag) */}
        <TextInputControl
          control={control}
          id={id}
          name={id}
          disabled={disabled}
          multiline={true}
          hiddenLabel={hiddenLabel}
          maxLength={ABOUT_COMPANY_MAX_LENGTHS.SWOT_ROW}
        />
      </Grid>
    </Grid>
  );
});
